import React from 'react';
import "../css/VideoSection.css"
import { Header } from 'semantic-ui-react';
import {useSelector} from "react-redux"

const VideoSection = () => {
    const lang = useSelector(  ( state) => state.languageReducer.currentLanguage)
    const renderHeader = (lang) =>{
        switch(lang){
            case "ru":
                return(
                    <Header className="video-section-header" size='medium'>Видео</Header>
                )
            case "us":
                return(
                    <Header className="video-section-header" size='medium'>Video</Header>
                )
            case "pl":
                return(
                    <Header className="video-section-header" size='medium'>Wideo</Header>
                )
        }

    }
    return (
        <div className="video-section">
            {/* <Header className="video-section-header" size='medium'>Video</Header> */}
            {renderHeader(lang)}
            <iframe 
            width="100%" height="450px" 
            src="https://www.youtube.com/embed/qQ5fbXVM6r8" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
        </div>
    )
}

export default VideoSection
